import React from 'react';
import { prepareInput, splitInputsByRenderBlock } from '../../Input';
import { studentFormInputs } from './studentFormInputs';
import { eventTypes, passportPatterns } from '../../utils';
import { checkNotEmpty, checkPassport } from '~h/validators';
import { passportFormatting } from '../../../../helpers/textFormatting';

class StudentForm extends React.Component {
  constructor(props) {
    super(props);

    const removeCONSULTInputs = ['citizenship', 'passport', 'passportPlaceCreated', 'passportCreated', 'addressOfRegistration', 'birthday'];
    const removeEDUInputs = ['passport', 'passportPlaceCreated', 'passportCreated'];

    let processedInputs;
    switch (this.props.eventTypes) {
      case eventTypes.CONSULT:
        processedInputs = studentFormInputs.filter(({name: fName}) => removeCONSULTInputs.findIndex((rName) => rName === fName) === -1);
        break;
      case eventTypes.EDU:
        processedInputs = studentFormInputs.filter(({name: fName}) => removeEDUInputs.findIndex((rName) => rName === fName) === -1);
        break;
      default:
        processedInputs = studentFormInputs;
    }

    this.state = {
      ...props.data,
      inputs: processedInputs,
    };
  }

  componentDidMount() {
    const newState = this.state;
    newState.citizenship = 'Российская Федерация';
    newState.citizenshipCode = 'RU';
    this.setState(newState);
  }

  validateForm = () => {
    const { inputs } = this.state;
    
    let isValidationPassed = true;
    
    const newInputs = inputs.slice(0)
      .filter(this.personalRegistrationFilter)
      .filter(this.companyRegistrationFilter)
      .map((input) => {
        const isValid = input.validator(this.state[input.name]);
        isValidationPassed = isValidationPassed && isValid;
        return { ...input, error: !isValid };
      });
      
    this.setState({ inputs: newInputs });
    return isValidationPassed;
  };

  validateInput = name => {
    const { inputs } = this.state;
    const currentInputIndex = inputs.findIndex(input => input.name === name);
    const currentInput = inputs[currentInputIndex];
    const isValid = currentInput.validator(this.state[currentInput.name]);
    if (!isValid !== currentInput.error) {
      const newInputs = inputs.slice(0);
      newInputs[currentInputIndex] = { ...currentInput, error: !isValid };
      this.setState({ inputs: newInputs });
    }
  };

  changeInput = (name, val) => {
    const { onChange } = this.props;
    const newState = this.state;

		if (name === 'citizenship') {
      const { citizenshipCode } = this.state;
		  if (val.citizenship || val.type === 'onChange' && val.citizenship === '') {
        const pattern = passportPatterns.find((mask) => mask.citizenshipCode === val.citizenshipCode);

        newState.inputs = newState.inputs.slice().map((inp) => {
          const newInp = Object.assign({}, inp);
          if (newInp.name === 'passport') {
            newInp.mask = pattern?.mask ? pattern.mask : '';
            newInp.validator = pattern ? checkPassport : checkNotEmpty;
            newInp.error = false;
          }
          return newInp;
        });

        newState.citizenship = val.citizenship;
        newState.citizenshipCode = val.citizenshipCode;

        if (pattern) newState.passport = passportFormatting(this.state.passport);
      } else if (!citizenshipCode) {
          newState.citizenship = '';
          newState.citizenshipCode = '';
        }
		} else {
      newState[name] = val;
    }

    this.setState(newState);
    const data = { ...newState };
    delete data.inputs;
    onChange(data);
  };

  personalRegistrationFilter = input =>
    this.props.companyRegistration ? true : input.isForPersonal;

  companyRegistrationFilter = input =>
    !this.props.companyRegistration ? true : input.isForCompany;

  render() {
    const { inputs } = this.state;

    const positionIndex = inputs.findIndex(
      input => input.name === 'companyPosition',
    );
    const position = { ...inputs[positionIndex] };
    if (positionIndex >= 0 && this.props.companyRegistration)
      position.renderBlock = 3;
    const preparedInputs = [...inputs];
    preparedInputs[positionIndex] = position;
    const splittedInputs = 
      splitInputsByRenderBlock(preparedInputs
        .filter(this.personalRegistrationFilter)
        .filter(this.companyRegistrationFilter),
    );

    return (
      <React.Fragment>
        <div className="registration__form">
          {splittedInputs.map((block) => (
            <div className="inp-wrap" key={`key-block-${block[0].name}`}>
              {block?.map(input =>
                prepareInput({
                  ...input,
                  value: this.state[input.name],
                  showAlert: this.props.showAlert,
                  removeSelection: this.props.removeSelection,
                  isPhoneCorrect: this.props.isPhoneCorrect,
                  onChangeCallback: this.changeInput,
                  onBlurCallback: this.validateInput,
                }),
              )}
            </div>
          ))}
        </div>

        <div className="separate" />
      </React.Fragment>
    );
  }
}

export default StudentForm;
